let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9xQWj")).then(() => parcelRequire('2L6ci'));